export enum FiatCurrencyTypeEnum {
  /** united-arab-emirates-dirham */
  AED = 'AED',
  /** afghan-afghani */
  AFN = 'AFN',
  /** armenian-dram */
  AMD = 'AMD',
  /** netherlands-antillean-guilder */
  ANG = 'ANG',
  /** argentine-peso */
  ARS = 'ARS',
  /** australian-dollar */
  AUD = 'AUD',
  /** aruban-florin */
  AWG = 'AWG',
  /** azerbaijani-manat */
  AZN = 'AZN',
  /** bosnia-herzegovina-convertible-mark */
  BAM = 'BAM',
  /** barbadian-dollar */
  BBD = 'BBD',
  /** bangladeshi-taka */
  BDT = 'BDT',
  /** bulgarian-lev */
  BGN = 'BGN',
  /** bahraini-dinar */
  BHD = 'BHD',
  /** burundian-franc */
  BIF = 'BIF',
  /** bermudan-dollar */
  BMD = 'BMD',
  /** binance-coin */
  BNB = 'BNB',
  /** brazilian-real */
  BRL = 'BRL',
  /** bitcoin */
  BTC = 'BTC',
  /** botswanan-pula */
  BWP = 'BWP',
  /** belarusian-ruble */
  BYN = 'BYN',
  /** belize-dollar */
  BZD = 'BZD',
  /** canadian-dollar */
  CAD = 'CAD',
  /** congolese-franc */
  CDF = 'CDF',
  /** swiss-franc */
  CHF = 'CHF',
  /** chilean-unit-of-account-(uf) */
  CLF = 'CLF',
  /** chilean-peso */
  CLP = 'CLP',
  /** chinese-yuan-(offshore) */
  CNH = 'CNH',
  /** cny */
  CNY = 'CNY',
  /** colombian-peso */
  COP = 'COP',
  /** cuban-convertible-peso */
  CUC = 'CUC',
  /** cuban-peso */
  CUP = 'CUP',
  /** cape-verdean-escudo */
  CVE = 'CVE',
  /** czech-republic-koruna */
  CZK = 'CZK',
  /** djiboutian-franc */
  DJF = 'DJF',
  /** danish-krone */
  DKK = 'DKK',
  /** dogecoin */
  DOGE = 'DOGE',
  /** dominican-peso */
  DOP = 'DOP',
  /** algerian-dinar */
  DZD = 'DZD',
  /** egyptian-pound */
  EGP = 'EGP',
  /** eritrean-nakfa */
  ERN = 'ERN',
  /** ethiopian-birr */
  ETB = 'ETB',
  /** ethereum */
  ETH = 'ETH',
  /** euro */
  EUR = 'EUR',
  /** fijian-dollar */
  FJD = 'FJD',
  /** falkland-islands-pound */
  FKP = 'FKP',
  /** british-pound-sterling */
  GBP = 'GBP',
  /** georgian-lari */
  GEL = 'GEL',
  /** guernsey-pound */
  GGP = 'GGP',
  /** ghanaian-cedi */
  GHS = 'GHS',
  /** gibraltar-pound */
  GIP = 'GIP',
  /** gambian-dalasi */
  GMD = 'GMD',
  /** guinean-franc */
  GNF = 'GNF',
  /** guatemalan-quetzal */
  GTQ = 'GTQ',
  /** guyanaese-dollar */
  GYD = 'GYD',
  /** hong-kong-dollar */
  HKD = 'HKD',
  /** honduran-lempira */
  HNL = 'HNL',
  /** croatian-kuna */
  HRK = 'HRK',
  /** haitian-gourde */
  HTG = 'HTG',
  /** hungarian-forint */
  HUF = 'HUF',
  /** indonesian-rupiah */
  IDR = 'IDR',
  /** israeli-new-sheqel */
  ILS = 'ILS',
  /** manx-pound */
  IMP = 'IMP',
  /** indian-rupee */
  INR = 'INR',
  /** iraqi-dinar */
  IQD = 'IQD',
  /** iranian-rial */
  IRR = 'IRR',
  /** icelandic-króna */
  ISK = 'ISK',
  /** jersey-pound */
  JEP = 'JEP',
  /** jamaican-dollar */
  JMD = 'JMD',
  /** jordanian-dinar */
  JOD = 'JOD',
  /** japanese-yen */
  JPY = 'JPY',
  /** kenyan-shilling */
  KES = 'KES',
  /** kyrgystani-som */
  KGS = 'KGS',
  /** cambodian-riel */
  KHR = 'KHR',
  /** comorian-franc */
  KMF = 'KMF',
  /** north-korean-won */
  KPW = 'KPW',
  /** south-korean-won */
  KRW = 'KRW',
  /** kuwaiti-dinar */
  KWD = 'KWD',
  /** cayman-islands-dollar */
  KYD = 'KYD',
  /** kazakhstani-tenge */
  KZT = 'KZT',
  /** laotian-kip */
  LAK = 'LAK',
  /** lebanese-pound */
  LBP = 'LBP',
  /** sri-lankan-rupee */
  LKR = 'LKR',
  /** liberian-dollar */
  LRD = 'LRD',
  /** lesotho-loti */
  LSL = 'LSL',
  /** litecoin */
  LTC = 'LTC',
  /** libyan-dinar */
  LYD = 'LYD',
  /** moldovan-leu */
  MDL = 'MDL',
  /** malagasy-ariary */
  MGA = 'MGA',
  /** macedonian-denar */
  MKD = 'MKD',
  /** myanma-kyat */
  MMK = 'MMK',
  /** mongolian-tugrik */
  MNT = 'MNT',
  /** macanese-pataca */
  MOP = 'MOP',
  /** mauritanian-ouguiya-(pre-2018) */
  MRO = 'MRO',
  /** mauritanian-ouguiya */
  MRU = 'MRU',
  /** mauritian-rupee */
  MUR = 'MUR',
  /** maldivian-rufiyaa */
  MVR = 'MVR',
  /** malawian-kwacha */
  MWK = 'MWK',
  /** mexican-peso */
  MXN = 'MXN',
  /** malaysian-ringgit */
  MYR = 'MYR',
  /** mozambican-metical */
  MZN = 'MZN',
  /** namibian-dollar */
  NAD = 'NAD',
  /** nigerian-naira */
  NGN = 'NGN',
  /** norwegian-krone */
  NOK = 'NOK',
  /** nepalese-rupee */
  NPR = 'NPR',
  /** new-zealand-dollar */
  NZD = 'NZD',
  /** omani-rial */
  OMR = 'OMR',
  /** panamanian-balboa */
  PAB = 'PAB',
  /** peruvian-nuevo-sol */
  PEN = 'PEN',
  /** papua-new-guinean-kina */
  PGK = 'PGK',
  /** philippine-peso */
  PHP = 'PHP',
  /** pakistani-rupee */
  PKR = 'PKR',
  /** polish-zloty */
  PLN = 'PLN',
  /** paraguayan-guarani */
  PYG = 'PYG',
  /** qatari-rial */
  QAR = 'QAR',
  /** romanian-leu */
  RON = 'RON',
  /** serbian-dinar */
  RSD = 'RSD',
  /** russian-ruble */
  RUB = 'RUB',
  /** rwandan-franc */
  RWF = 'RWF',
  /** saudi-riyal */
  SAR = 'SAR',
  /** sudanese-pound */
  SDG = 'SDG',
  /** swedish-krona */
  SEK = 'SEK',
  /** singapore-dollar */
  SGD = 'SGD',
  /** sierra-leonean-leone */
  SLL = 'SLL',
  /** somali-shilling */
  SOS = 'SOS',
  /** surinamese-dollar */
  SRD = 'SRD',
  /** são-tomé-and-príncipe-dobra-(pre-2018) */
  STD = 'STD',
  /** salvadoran-colón */
  SVC = 'SVC',
  /** syrian-pound */
  SYP = 'SYP',
  /** swazi-lilangeni */
  SZL = 'SZL',
  /** thai-baht */
  THB = 'THB',
  /** tajikistani-somoni */
  TJS = 'TJS',
  /** tunisian-dinar */
  TND = 'TND',
  /** turkish-lira */
  TRY = 'TRY',
  /** trinidad-and-tobago-dollar */
  TTD = 'TTD',
  /** new-taiwan-dollar */
  TWD = 'TWD',
  /** tanzanian-shilling */
  TZS = 'TZS',
  /** ukrainian-hryvnia */
  UAH = 'UAH',
  /** ugandan-shilling */
  UGX = 'UGX',
  /** united-states-dollar */
  USD = 'USD',
  /** tether */
  USDT = 'USDT',
  /** uruguayan-peso */
  UYU = 'UYU',
  /** uzbekistan-som */
  UZS = 'UZS',
  /** venezuelan-bolívar-fuerte */
  VEF = 'VEF',
  /** ves */
  VES = 'VES',
  /** vietnamese-dong */
  VND = 'VND',
  /** vanuatu-vatu */
  VUV = 'VUV',
  /** samoan-tala */
  WST = 'WST',
  /** cfa-franc-beac */
  XAF = 'XAF',
  /** silver-ounce */
  XAG = 'XAG',
  /** gold-ounce */
  XAU = 'XAU',
  /** east-caribbean-dollar */
  XCD = 'XCD',
  /** special-drawing-rights */
  XDR = 'XDR',
  /** cfa-franc-bceao */
  XOF = 'XOF',
  /** cfp-franc */
  XPF = 'XPF',
  /** platinum-ounce */
  XPT = 'XPT',
  /** yemeni-rial */
  YER = 'YER',
  /** south-african-rand */
  ZAR = 'ZAR',
  /** zcash */
  ZEC = 'ZEC',
  /** zambian-kwacha */
  ZMW = 'ZMW',
  /** zimbabwean-dollar */
  ZWL = 'ZWL',
}
